import React, { useState } from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import SearchModal from './SearchModal';

const SearchButton = ({ className = '' }) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const handleSearchClick = () => {
    setIsSearchOpen(true);
  };

  const handleSearchClose = () => {
    setIsSearchOpen(false);
  };

  return (
    <>
      {/* Search Button */}
      <button
        onClick={handleSearchClick}
        className={`flex items-center gap-2 px-3 py-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors ${className}`}
        aria-label="Search"
      >
        <MagnifyingGlassIcon className="h-5 w-5" />
        <span className="hidden sm:inline text-sm">Search</span>
      </button>

      {/* Search Modal */}
      <SearchModal 
        isOpen={isSearchOpen} 
        onClose={handleSearchClose} 
      />
    </>
  );
};

export default SearchButton;